import React, { useEffect, useState } from "react";
import SEO from "../Seo";
import { Container, Box, Stack, Typography, CircularProgress } from "@mui/material";
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import readmore from '../../assets/images/read-more-icon.png'
import './style.scss'
import { useNavigate } from "react-router-dom";
import { getAllBlogs } from "../../services/blog";

const BlogPage = () => {
  const [blogs, setBlogs] = useState([])
  const [loading, setLoading] = useState(false)

  const getBlogs = async () => {
    try {
      const response = await getAllBlogs();
      const sortedBlogs = response?.data?.sort((a, b) => new Date(b?.date) - new Date(a?.date))
      setBlogs(sortedBlogs || [])
    } catch (error) {
      console.log("error", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    setLoading(true)
    getBlogs()
  }, [])

  const navigate = useNavigate()

  const handleReadMore = (id) => {
    navigate(`/blog/${id}`)
  }

  return (
    <>
      <SEO page="home" /> {/* Load metadata for the home page */}
      <Box component="section" className="blog-content" py={5}>
        <Container>
          {
            loading ? (
              <div className="loading-container">
                <CircularProgress />
              </div>
            ) : (
              blogs && blogs?.map((item, index) => (
                <div key={index} className="blog-item">
                  <h2 className="blog-title" onClick={() => handleReadMore(item?.slug)}>{item?.title?.rendered}</h2>
                  <p className="blog-published-date">
                    Published {new Date(item?.date).toLocaleString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
                  </p>
                  <div className="blog-content-text">
                    {parse(DOMPurify.sanitize(item?.excerpt?.rendered))}
                  </div>
                  <div className="blog-read-more-btn" onClick={() => handleReadMore(item?.slug)}>
                    <span>READ MORE</span>
                    <img src={readmore} alt="arrow right" />
                  </div>
                </div>
              ))
            )}

          {
            !loading && blogs?.length === 0 && (
              <div className="no-blogs-container">
                <Typography variant="h6">No blogs found</Typography>
              </div>
            )
          }
        </Container>
      </Box>

    </>
  );
};

export default BlogPage;